import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Spinner } from 'reactstrap'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './App.css';

function App(props) {
  const [current, setCurrent] = useState(0)
  const [pics, setPics] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    async function fetchData() {
      let after
      let myPics
      if (!after) {
        const res = await fetch('/.netlify/functions/instagram?id=16354850715').then(res => res.json())
        if (!res) return
        myPics = [...res.data]
        after = res.after
      }

      while(after) {
        const newRes = await fetch(`/.netlify/functions/instagram?id=16354850715&after=${after}`).then(res => res.json())
        if (!newRes) return
        myPics = [...myPics, ...newRes.data]
        after = newRes.after
      }

      setPics(myPics)
      setLoading(false)
    }

    fetchData()
  },[])


  if (loading || !pics.length) {
    return (
      <div className="App">
        <header className="App-header">
          <Spinner color="light" />
        </header>
      </div>
    )
  }
  return (
    <div className="App">
      <header className="App-header">
        <Carousel 
          className="carousel"
          showIndicators={false}
          useKeyboardArrows={true}
          showArrows={true}
          showThumbs={false}
          selectedItem={current} 
          onChange={index => {
            if (current !== index) {
              setCurrent(index)
            }
          }}
        >
          {pics.map(el => (
            <div key={el.id}>
              <img src={el.imgUrl} alt={el.id} />
            </div>
          ))}
        </Carousel>
        <div className='mt-2'>
          <ButtonGroup>
            <Button color="primary" onClick={() => {
              setCurrent(0)
            }}>First</Button>
            <Button disabled={current === 0} onClick={() => {
              if (current === 0) {
                return 
              }
              setCurrent(current - 1)
            }}>Previous</Button>
            <Button disabled={current === pics.length} onClick={() => {
              if (current === pics.length - 1) {
                return 
              }
              setCurrent(current + 1)
            }}>Next</Button>
            <Button color="primary" onClick={() => {
              setCurrent(pics.length - 1)
            }}>Last</Button>
          </ButtonGroup>
        </div>
      </header>
    </div>
  );
}

export default App;
